import { Component, computed, HostListener, inject, Input, OnInit } from '@angular/core';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorComponent } from '@progress/kendo-angular-inputs';
import { OrderResumeComponent } from 'src/app/pages/form/order-resume/order-resume.component';
import { SpacerComponent } from 'src/app/ui/atoms/spacer/spacer.component';
import { ScheduleComponent } from 'src/app/pages/form/schedule/schedule.component';
import { LanguageService } from 'src/app/services/language.service';
import { StepsService } from 'src/app/services/steps.service';
import { DialogContainerDirective, DialogService } from '@progress/kendo-angular-dialog';
import { FormService } from 'src/app/services/form.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-payment-selection',
    imports: [
        TranslatePipe,
        ErrorComponent,
        ButtonComponent,
        ReactiveFormsModule,
        OrderResumeComponent,
        SpacerComponent,
        ScheduleComponent,
        DialogContainerDirective,
        DatePipe,
    ],
    templateUrl: './payment-selection.component.html',
    styleUrl: './payment-selection.component.scss'
})
export class PaymentSelectionComponent implements OnInit {
  private languageService = inject(LanguageService);
  private translateService = inject(TranslateService);
  private dialogService = inject(DialogService);
  private stepService = inject(StepsService);
  public formService = inject(FormService);

  @Input({required: true}) formId: string;

  form = this.formService.form;
  lang = computed(() => this.languageService.currentLanguage());

  formGroup: FormGroup;
  chosenButton: boolean | null;
  smallWidth = false;

  ngOnInit() {
    this.onResize();

    this.formGroup = new FormGroup({
      reservation: new FormControl<boolean | undefined>(undefined, Validators.required),
    });

    this.formGroup.valueChanges.subscribe(() => this.buildPaymentChoiceData());

    this.formService.update({
      ...this.formService.form(),
      isReservation: undefined
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.smallWidth = window.innerWidth < 482;
  }

  private buildPaymentChoiceData() {
    const values = this.formGroup.getRawValue();
    this.formService.update({
      ...this.formService.form(),
      isReservation: values.reservation
    });
  }

  confirmReservation() {
    const dialog = this.dialogService.open({
      title: this.translateService.instant('bookingHandler.inStorePayment.title'),
      content: this.translateService.instant('bookingHandler.inStorePayment.description'),
      actions: [
        { text: this.translateService.instant('close'), fillMode: 'outline', themeColor: 'primary', value: false },
        { text: this.translateService.instant('confirm'), themeColor: 'primary', value: true }
      ],
    });

    dialog.result.subscribe((result: any) => {
      if (result?.value) this.setReservationMethod(true);
    });
  }

  public setReservationMethod(value: boolean) {
    this.chosenButton = value;
    this.formGroup.get('reservation')?.setValue(value);
    this.submit();
    this.stepService.nextStepHandler();
  }

  submit() {
    this.formGroup.markAllAsTouched();
    this.buildPaymentChoiceData();
  }

  back() {
    this.stepService.previousStepHandler();
  }
}
